import {memo, shapeComponent, ShapeComponent, StyleSheet, Text, useBreakpoint, useI18n, useStyles, View} from "shared/base"
import ActiveStep from "./active-step"
import AppHistory from "shared/history"
import Button from "components/chalky-layout/button"
import ButtonUnderscore from "components/chalky-layout/button-underscore"
import ChalkyLayout from "components/chalky-layout"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import React from "react"
import RoleCard from "./role-card"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import StripedPressable from "components/chalky-layout/striped-pressable"

const styles = StyleSheet.create({
  mb15: {
    marginBottom: 15
  },

  buttonContainer: {
    flexDirection: "row"
  },
  buttonContainerSmDown: {
    marginBottom: 32
  },
  buttonContainerMdUp: {
    justifyContent: "end"
  },

  rootContainer: {},
  rootContainerMdUp: {
    flexDirection: "row"
  },

  roleCardsContainer: {},
  roleCardsContainerXlUp: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },

  rolesContainer: {},
  rolesContainerMdUp: {
    flex: 1
  },

  roleCard: {},
  roleCardLgDown: {
    marginBottom: 15
  },
  roleCardXlUp: {
    marginBottom: 15,
    width: "49%"
  },

  skipThisStepButtonContainer: {
    marginRight: 10
  },
  skipThisStepButtonContainerSmDown: {
    flex: 1,
    marginRight: 10
  },

  continueButtonContainer: {},
  continueButtonContainerSmDown: {
    flex: 1,
    marginLeft: 10
  },

  yourRoleDescription: {
    marginBottom: 30,
    color: "#2c2c96",
    fontSize: 16
  },

  yourRoleColumn: {
    paddingTop: 37
  },
  yourRoleColumnMdUp: {
    marginTop: "auto",
    marginBottom: "auto",
    width: 300,
    paddingRight: 30
  },
  yourRoleColumnLgUp: {
    width: 500,
    paddingRight: 80
  },

  yourRoleWithDescription: {},
  yourRoleWithDescriptionMdUp: {
    marginTop: -12,
    marginLeft: 30
  },
  yourRoleWithDescriptionLgUp: {
    marginLeft: 52
  },

  yourRole: {
    marginBottom: -25,
    color: "#2c2c96",
    fontFamily: "DreamChaser",
    fontSize: 64
  },
  yourRoleSmDown: {
    textAlign: "center"
  },
  yourRoleMdUp: {
    fontFamily: "DreamChaser",
    fontSize: 64
  }
})

export default memo(shapeComponent(class RoutesUserCreateUserStep1 extends ShapeComponent {
  setup() {
    setLayout("front")

    const {t} = useI18n({namespace: "js.routes.user.create_user.step1"})

    this.setInstance(useBreakpoint())
    this.setInstance({t})
    this.useStates({
      activeCard: null,
      readMore: false
    })
  }

  render() {
    const {mdUp, smDown, t} = this.tt
    const {activeCard, readMore} = this.s
    const buttonContainerStyle = useStyles(styles, "buttonContainer")
    const continueButtonContainerStyle = useStyles(styles, "continueButtonContainer")
    const skipThisStepButtonContainerStyle = useStyles(styles, "skipThisStepButtonContainer")
    const rootContainerStyle = useStyles(styles, "rootContainer")
    const yourRoleColumnStyle = useStyles(styles, "yourRoleColumn")
    const rolesContainerStyle = useStyles(styles, "rolesContainer")
    const yourRoleStyle = useStyles(styles, "yourRole")
    const yourRoleDescriptionStyle = useStyles(styles, "yourRoleDescription")
    const yourRoleWithDescriptionStyle = useStyles(styles, "yourRoleWithDescription")
    const roleCardsContainerStyle = useStyles(styles, "roleCardsContainer")
    const roleCardStyle = useStyles(styles, "roleCard")

    const inactiveSteps = () => (
      <View>
        <ActiveStep description={t(".your_preferences")} label={t(".step_2")} />
        <ActiveStep description={t(".youre_ready")} label={t(".step_3")} />
      </View>
    )

    return (
      <ChalkyLayout dataSet={this.layoutDataSet ||= {route: "user/create-user/step1"}} layout="front" maxWidth={1260} requireUser={false}>
        <View dataSet={this.rootContainerDataSet ||= {class: "root-container"}} style={rootContainerStyle}>
          <View dataSet={this.yourRoleColumnDataSet ||= {class: "your-role-column"}} style={yourRoleColumnStyle}>
            <ActiveStep active label={t(".step_1")} />
            <View style={yourRoleWithDescriptionStyle}>
              <Text style={yourRoleStyle}>
                {t(".your_role")}
              </Text>
              {!mdUp &&
                <View style={styles.mb15}>
                  <StripedPressable onPress={this.tt.onReadMorePress}>
                    <Text>
                      {readMore ? t(".read_less") : t(".read_more")}
                    </Text>
                  </StripedPressable>
                </View>
              }
              {(mdUp || readMore) &&
                <Text style={yourRoleDescriptionStyle}>
                  {t(".your_role_description")}
                </Text>
              }
            </View>
            {mdUp && inactiveSteps()}
          </View>
          <View dataSet={this.rolesContainerDataSet ||= {class: "roles-container"}} style={rolesContainerStyle}>
            <View style={roleCardsContainerStyle}>
              <View style={roleCardStyle}>
                <RoleCard
                  active={activeCard == "teacher"}
                  header={t(".teacher")}
                  icon="chalkboard-user"
                  iconVersion="FontAwesome6"
                  identifier="teacher"
                  onCardPress={this.tt.onTeacherCardPress}
                />
              </View>
              <View style={roleCardStyle}>
                <RoleCard
                  active={activeCard == "principal-administrator"}
                  header={t(".principal_administrator")}
                  icon="school"
                  iconVersion="FontAwesome5"
                  identifier="principal-administrator"
                  onCardPress={this.tt.onPrincipalAdministratorCardPress}
                />
              </View>
              <View style={roleCardStyle}>
                <RoleCard
                  active={activeCard == "well-being-coordinator"}
                  header={t(".well_being_coordinator")}
                  icon="hand-holding-heart"
                  iconVersion="FontAwesome5"
                  identifier="well-being-coordinator"
                  onCardPress={this.tt.onWellBeingCoordinatorCardPress}
                />
              </View>
              <View style={roleCardStyle}>
                <RoleCard
                  active={activeCard == "other"}
                  header={t(".other")}
                  icon="person"
                  iconVersion="FontAwesome6"
                  identifier="other"
                  onCardPress={this.tt.onOtherCardPress}
                />
              </View>
            </View>
            <View style={buttonContainerStyle}>
              <View style={skipThisStepButtonContainerStyle}>
                <ButtonUnderscore
                  dataSet={this.skipThisStepButtonDataSet ||= {class: "skip-button"}}
                  onPress={this.tt.onSkipThisStepPress}
                  primary
                  title={t(".skip_this_step")}
                />
              </View>
              <View style={continueButtonContainerStyle}>
                <Button dataSet={this.continueButtonDataSet ||= {class: "continue-button"}} onPress={this.tt.onContinuePress} primary title={t(".continue")} />
              </View>
            </View>
          </View>
          {smDown && inactiveSteps()}
        </View>
      </ChalkyLayout>
    )
  }

  onContinuePress = () => {
    const {t} = this.tt
    const {activeCard} = this.s

    if (!activeCard) {
      FlashMessage.alert(t(".please_choose_a_role"))

      return
    }

    AppHistory.push(Routes.userCreateUserStep2Path({role: activeCard}))
  }

  onOtherCardPress = () => this.triggerActiveCard("other")
  onPrincipalAdministratorCardPress = () => this.triggerActiveCard("principal-administrator")
  onReadMorePress = () => this.setState({readMore: !this.s.readMore})
  onSkipThisStepPress = () => AppHistory.push(Routes.userCreateUserStep2Path())
  onTeacherCardPress = () => this.triggerActiveCard("teacher")
  onWellBeingCoordinatorCardPress = () => this.triggerActiveCard("well-being-coordinator")

  triggerActiveCard(cardIdentifier) {
    const {activeCard} = this.s

    if (cardIdentifier == activeCard) {
      this.setState({activeCard: null})
    } else {
      this.setState({activeCard: cardIdentifier})
    }
  }
}))
